import React from 'react';



export default function Descargas() {
    return (
        <div className='container mt-5'>
            <div className="mt-5 d-flex justify-content-between">
                <div className="card" style={{ width: '18rem' }}>
                    <div className="card-body">
                        <img style={{width: '100px', marginBottom: '20px'}} src="/assets/encuesta.png" alt="encuesta-logo" />
                        <h5 className="card-title">Diseño de encuesta</h5>
                        <p className="card-text">Copia de la encuesta aplicada a los productores de berries y cherries de la región del Biobío.</p>
                        <div className="d-flex justify-content-between">
                            <a href="https://arcg.is/1vPDHy" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>Version Web</a>
                            <a href="https://bit.ly/3ExLOWg" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>Documento</a>
                        </div>
                    </div>
                </div>

                <div className="card" style={{ width: '18rem' }}>
                    <div className="card-body">
                        <img style={{width: '100px', marginBottom: '20px'}} src="/assets/diccionario.png" alt="diccionario-logo" />
                        <h5 className="card-title">Diccionario de datos</h5>
                        <p className="card-text">Planilla que incluye los códigos e interpretaciones de la base de datos resultante de la encuesta</p>
                        <a href="https://bit.ly/3pC6M1P" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>Descargar</a>
                    </div>
                </div>

                <div className="card" style={{ width: '18rem' }}>
                    <div className="card-body">
                        <img style={{width: '100px', marginBottom: '20px'}} src="/assets/results.png" alt="resultados-logo" />
                        <h5 className="card-title">Resultado de la base de datos</h5>
                        <p className="card-text">Contiene la totalidad de encuestas capturadas.</p>
                        <div className="d-flex justify-content-between">
                            <a href="https://bit.ly/3A0jvPv" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>XLS</a>
                            <a href="https://bit.ly/31Z65qs" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>SHP</a>
                            <a href="https://bit.ly/3GwpUoa" rel="noopener noreferrer" target="_blank" className="btn btn-primary" style={{ backgroundColor: '#bb4c4b', borderColor: '#bb4c4b' }}>KML</a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
